import { Box } from '@mui/material'
import { motion } from 'motion/react'
import { Link } from 'react-router-dom'
import { BtnsHoverAnimation } from '../../../../utils/animation'

const MotionBox = motion.create(Box)

const SideButtonContainerItem = ({
  onClick, to, customStyle, children, ...rest
}) => (
  <MotionBox
    sx={[styles.sideButton, customStyle]}
    onClick={onClick}
    {...rest}
    component={to ? Link : 'div'}
    variants={BtnsHoverAnimation}
    whileHover="hover"
    to={to}
  >
    {children}
  </MotionBox>
)

const styles = {
  sideButton: {
    fontFamily: 'Avenir',
    textTransform: 'capitalize',
    cursor: 'pointer',
    paddingTop: '8px',
    width: '100%',
    borderRadius: '5px',
    '&:hover': {
      backgroundColor: 'background.default',
    },

    display: 'flex',
    alignItems: 'flex-end',
    gap: '13px',
    margin: { xs: '30px 0px', sm: '10px 10px 0px 0px' },
    padding: '0px 0px 10px !important',
    '& span': {
      fontSize: { xs: '14px', sm: '18px' },
      lineHeight: '22px',
    },
    '& svg': {
      width: '25px',
      height: '25px',
      paddingTop: '7px',
    },
    textDecoration: 'none',
    color: 'initial',
  },
}

export default SideButtonContainerItem
